<template>
  <div>
    <wt-dropdown
      :items="options"
      :type="type"
      :on-click-item="changeOrganization"
      :current-item-id="selected"
      v-if="showOrganizationList"
      class="wt2-organizations-dropdown align-self-center"
    >
      <template slot="item" slot-scope="props">
        <span v-text-right>{{ props.item.label }}</span>
      </template>
    </wt-dropdown>
  </div>
</template>

<script>
import app from 'app';
import { mapState } from 'vuex';

export default {
  store() {
    return app.rootStore;
  },
  props: {
    currentOrganizationId: {
      type: Number,
      required: false,
      default: 0,
    },
    type: {
      type: String,
      default: 'underline fixed',
    },
  },
  computed: {
    options() {
      return this.organizations.map(
        ({ organizationName: label, organizationId: id }) => ({ label, id })
      );
    },
    selected() {
      return this.currentOrganizationId || this.selectedOrganizationId;
    },
    showOrganizationList() {
      return this.options.length > 1;
    },
    ...mapState('user', ['organizations', 'selectedOrganizationId']),
  },
  methods: {
    changeOrganization(orgId) {
      this.setOrganizationId(orgId);
    },

    setOrganizationId(orgId) {
      // this.currentOrganizationId = orgId;
      this.$emit('update:currentOrganizationId', orgId);
    },
  },
};
</script>
